module.exports = __webpack_public_path__ + "img/2013yuenan.b88fe490.png";